module.exports = {
  HtmlContent: {
    PluginName: "HTML Content",
  },
};
